/**
 *
 * Custom Element
 * x-input-limit
 *
 */

class InputLimitElement extends HTMLElement {
  static INPUT_SELECTOR = '[data-role="input"]'
  static CHAR_LIMIT_SELECTOR = '[data-role="char_limit_count"]'
  constructor() {
    super()
    this.counterMinimum = 0
    this.counterMax = 200
  }

  /**
   *
   * @param {*} event inputEvent
   */
  _onInputCallBack(event) {
    const { value } = event.target
    const { maxed, counter } = this._checkTotalCharacters(value)
    if (maxed) {
      const slicedMax = value.slice(0, this.counterMax)
      event.target.value = slicedMax
    }
    this._updateCounter(counter)
  }

  /**
   *
   * @param {*} input Number
   */
  _updateCounter(input) {
    this.counter.innerText = input
  }

  _checkTotalCharacters(input) {
    const totalCharacters = input.length

    if (totalCharacters <= this.counterMinimum) {
      return {
        counter: 0,
        input: '',
        maxed: false
      }
    }
    if (totalCharacters >= this.counterMax + 1) {
      return {
        counter: this.counterMax,
        input,
        maxed: true
      }
    }
    return {
      counter: totalCharacters,
      input,
      maxed: false
    }
  }

  fetchChildren() {
    this.input = this.querySelector(InputLimitElement.INPUT_SELECTOR)
    this.counter = this.querySelector(InputLimitElement.CHAR_LIMIT_SELECTOR)
  }

  addEventListeners() {
    if (!this.input || !this.counter) return
    this.input.addEventListener('input', this._onInputCallBack.bind(this))
  }

  removeEventListeners() {
    if (!this.input || !this.counter) return
    this.input.removeEventListener('input', this._onInputCallBack.bind(this))
  }

  connectedCallback() {
    this.fetchChildren()
    this.addEventListeners()
  }

  disconnectedCallback() {
    this.removeEventListeners()
  }
}

customElements.define('x-input-limit', InputLimitElement)
